import { render } from "./ExpressPageList.vue?vue&type=template&id=238bda24&scoped=true&ts=true"
import script from "./ExpressPageList.vue?vue&type=script&lang=ts"
export * from "./ExpressPageList.vue?vue&type=script&lang=ts"

import "./ExpressPageList.vue?vue&type=style&index=0&id=238bda24&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238bda24"]])

export default __exports__